import { Component, Inject,NgModule } from '@angular/core';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PasswordModalComponent } from '../password-modal/password-modal.component';

@Component({
  selector: 'app-change-password',
  standalone: true,
  imports: [],
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss', '../../../app.component.scss']
})
export class ChangePasswordComponent {
  public dialogRef: MatDialogRef<PasswordModalComponent>
  @Inject(MAT_DIALOG_DATA) public data: any
  constructor(public dialog: MatDialog) { }

  @NgModule({
    imports: [
      MatDialogModule,
    ],
  })

  // openEditDialog(): void {
  //     const dialogRef = this.dialog.open(AddMasterProductComponent, {
  //       disableClose: true,
  //       data: {
  //         type: "edit",
  //       }
  //     }).afterClosed().subscribe(() => 
  //     // this.getMasterBodyParts()
  //   );
  // }

  openEditDialog(): void {
    const dialogRef = this.dialog.open(PasswordModalComponent, {
      disableClose: true,
      data: {
        type: "edit", 
      }
    }).afterClosed().subscribe(()=>{
      // this.toastMessage.showToast("Password has been successfully updated", "success");
        this.onClose();
    });
  }

   onClose(): void {
    this.dialogRef.close();
  }
}
